const init = () => {
    document.addEventListener('change', (e) => {
        if (e.target.matches('.js-select-product-category')) {
            window.location.href = e.target.value;
        }
    });
};

export default init;
